import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { Time } from '@angular/common';
@Injectable({
  providedIn: 'root'
})
export class OrderService {

  private notifyOrderTypeChange = new BehaviorSubject<string>(null);

  base_url: string;
  constructor(
    public http: HttpClient,
  ) {
    this.base_url = environment.appUrl + "/orders";
  }

  /*getAllOrders(orderType: String, page:number): Observable<any> {
    return this.http.get(this.base_url + '/' + orderType + '?page=' + page)
  }*/

  getAllOrders(): Observable<any> {
    return this.http.get(this.base_url);
  }

  getAllOrdersByTypes(orderTypes, page: number): Observable<any> {
    return this.http.get(this.base_url + '/types' + '?page=' + page + '&types=' + orderTypes + '&branches=' + JSON.parse(window.sessionStorage.getItem("userBranchNames")))
  }

  getAllProductsInOrder(orderId: Number): Observable<any> {

    //change post url next to base_url 
    return this.http.get(this.base_url + '/id/' + orderId + '/' + "products")
  }

  
  getOrder(orderId: Number): Observable<any> {
    return this.http.get(this.base_url + '/id/' + orderId)
  }

  getOrderCountByStatus(from, to, orderTypes: Array<string>): Observable<any> {
    //change post url next to base_url 
    return this.http.get(this.base_url + '/status/count/branch?fromDate=' + from + '&toDate=' + to + '&orderTypes=' + orderTypes);
  }

  prepareOrderForDelivery(order): Observable<any> {
    return this.http.post(this.base_url + '/splitorder', order)
  }

  orderUpdate(order): Observable<any> {
    return this.http.put(this.base_url, order)
  }

  getChartData(orderTypes: Array<string>): Observable<any> {
    // return this.http.get('http://springbootapis-env.ak3dt4wpjm.ap-south-1.elasticbeanstalk.com/orders/dashboard/trendanalysis');
    return this.http.get(this.base_url + '/dashboard/trendanalysis?orderTypes=' + orderTypes);

  }

  getChartFleet(): Observable<any> {
    //return this.http.get(' http://springbootapis-env.ak3dt4wpjm.ap-south-1.elasticbeanstalk.com/orders/dashboard/statbyfleet');
    return this.http.get(this.base_url + '/dashboard/statbyfleet');

  }

  getChartZone(): Observable<any> {
    //return this.http.get('http://springbootapis-env.ak3dt4wpjm.ap-south-1.elasticbeanstalk.com/orders/dashboard/statbyzone');
    return this.http.get(this.base_url + '/dashboard/statbyzone');

  }

  orderStateChange(id, state): Observable<any> {
    return this.http.patch(this.base_url + "/id/" + id + "/" + state, null)
  }

  orderPickedUpByCustomer(id, remarksCustomerPickup): Observable<any> {
    return this.http.patch(this.base_url + "/id/" + id + "/customerpickup", JSON.stringify(remarksCustomerPickup));
  }

  podImageData(orderid): Observable<any> {
    return this.http.get(this.base_url + "/preSignedURLs/" + orderid);
  }

  eSignImage(orderid): Observable<any> {
    return this.http.get(this.base_url + "/preSignedURLsEsign/" + orderid);
  }

  presignedSnSignImage(orderid): Observable<any> {
    return this.http.get(this.base_url + "/preSignedURLsProductSerialNo/" + orderid);
  }

  orderInStock(orderid) {
    return this.http.patch(this.base_url + "/id/" + orderid + "/getstockstatus", null);
  }

  deleteOrder(selectedOrderList): Observable<any> {
    return this.http.put(this.base_url + "/multipleDelete", selectedOrderList);
  }

  adminDeliverOrder(orderid) {
    return this.http.put(this.base_url + "/" + orderid + "/adminupdatedelivery/", null);
  }

  adminRescheduleDelivery(order) {
    return this.http.put(this.base_url + "/stock/postponedelivery/", order);
  }

  getZoneList(): Observable<any> {
    return this.http.get(this.base_url + '/zones');
  }

  getAllOrdersByTypesDateRange(orderTypes, page: number, from: Date, to: Date, selectedZone: string): Observable<any> {
    return this.http.get(this.base_url + '/typesdaterange' + '?page=' + page + '&types=' + orderTypes + '&fromDate=' + from + '&toDate=' + to  + '&branches=' + JSON.parse(window.sessionStorage.getItem("userBranchNames")) + '&zone=' + selectedZone);

  }

  getAllOrdersByTypesAndOTypesDateRange(orderTypes, oTypes, page: number, from: Date, to: Date, selectedZone: string): Observable<any> {
    return this.http.get(this.base_url + '/diag/typesdaterange' + '?page=' + page + '&oStates=' + orderTypes + '&fromDate=' + from + '&toDate=' + to + '&branches=' + JSON.parse(window.sessionStorage.getItem("userBranchNames")) + '&zone=' + selectedZone + '&oTypes=' + oTypes);
  }

  getJobDetails(orderid): Observable<any> {
    return this.http.get(this.base_url + '/id/' + orderid + '/job');
  }

  getCustomerFeedack(orderid): Observable<any> {
    return this.http.get(environment.appUrl + '/customerfeedback/id/' + orderid);
  }

  getOrderReport(from, to): Observable<any> {
    return this.http.get(environment.appUrl + '/reports/orderSummary?fromDate=' + from + '&toDate=' + to);
  }

  getOrderReportByStates(from, to , orderStates): Observable<any> {
    return this.http.get(environment.appUrl + '/reports/orderSummary?fromDate=' + from + '&toDate=' + to +'&orderState=' + orderStates);
  }

  deleteDuplicateOrders(from, to , orderStates): Observable<any> {
    return this.http.get(environment.appUrl + '/reports/deleteDuplicateOrders?fromDate=' + from + '&toDate=' + to +'&orderState=' + orderStates);
  }

  getOrderDetails(orderid): Observable<any> {
    return this.http.get(this.base_url + '/id/' + orderid);
  }

  changeProductSerialNumber(order) {
    return this.http.put(this.base_url + "/updateserialnumber", order);
  }

  addOrderPH(newOrder): Observable<any> {
    JSON.stringify(newOrder);
    console.log(newOrder);
    return this.http.post(environment.appUrl + '/pathlab/addorders', newOrder)
  }

  rescheduleOrder(orderInvoiceNumber: string, newEtaDate: string): Observable<any> {
    return this.http.put(this.base_url + '/reschedule?orderInvoiceNumber=' + orderInvoiceNumber + '&newEtaDate=' + newEtaDate, null);
  }

  notifyChildOfOrderTypeChange(orderType: string) {
    this.notifyOrderTypeChange.next(orderType);
  }

  getOrderType(): Observable<string> {
    return this.notifyOrderTypeChange.asObservable();
  }

  getOrderSummaryReport(from, to): Observable<any> {
    return this.http.get(environment.appUrl + '/reports/orderstatsbybranch?fromDate=' + from + '&toDate=' + to);
  }

  getSmsReport(from, to): Observable<any> {
    return this.http.get(environment.appUrl + '/reports/smscount?fromDate=' + from + '&toDate=' + to);
  }

  splitOrder(splittedOrder): Observable<any>{
    return this.http.post(this.base_url + "/splitorder", splittedOrder);
  }

  orderUpdateBajaj(order): Observable<any> {
    return this.http.put(this.base_url + '?isTypeStateChange=true', order)
  }
}